import React, {FC, MouseEventHandler, useContext, useEffect} from 'react';
import {PortalContext} from 'modules/portal/context/PortalContext';
import classNames from 'classnames';
import style from './style.module.scss';
import Icon from 'components/Icon';

interface IModalOverlayMedia {
    onClose?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    onPrevButtonClick?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    onNextButtonClick?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    isVideo?: boolean;
}

export const ModalOverlayMedia: FC<IModalOverlayMedia> = ({onPrevButtonClick, onNextButtonClick, onClose, isVideo}) => {
    const {visibility} = useContext(PortalContext);

    useEffect(() => {
        const handleEscKey = (event: KeyboardEvent) => {
            if ('Escape' === event.key && visibility && onClose) {
                onClose(event as any);
            }
        };

        window.addEventListener('keydown', handleEscKey);
        return () => {
            window.removeEventListener('keydown', handleEscKey);
        };
    }, [visibility, onClose]);

    return (
        <div>
            <div>
                <button
                    className={classNames(style.closeButton, 'regular-modal-close-button')}
                    data-modal-action={'close'}
                    onClick={onClose}
                >
                    <Icon icon={'close'} />
                </button>
            </div>
            <div
                onClick={onClose}
                className={classNames(style.modalOverlay, style.modalOverlayCloseTop, {
                    [style.modalOverlayVisible]: visibility,
                    [style.isVideo]: isVideo,
                })}
            />
            {!isVideo && (
                <>
                    <div
                        onClick={onPrevButtonClick}
                        className={classNames(style.modalOverlay, style.modalOverlayPrev, {
                            [style.modalOverlayVisible]: visibility,
                        })}
                    >
                        <button className={classNames(style.navigateButton, style.buttonLeft)}>
                            <Icon icon={'chevron-left'} />
                        </button>
                    </div>
                    <div
                        onClick={onNextButtonClick}
                        className={classNames(style.modalOverlay, style.modalOverlayNext, {
                            [style.modalOverlayVisible]: visibility,
                        })}
                    >
                        <button className={classNames(style.navigateButton, style.buttonRight)}>
                            <Icon icon={'chevron-right'} />
                        </button>
                    </div>
                </>
            )}
            <div
                onClick={onClose}
                className={classNames(style.modalOverlay, style.modalOverlayCloseBottom, {
                    [style.modalOverlayVisible]: visibility,
                    [style.isVideo]: isVideo,
                })}
            />
        </div>
    );
};
